import { HCConfig, HCConfigAssets, HCConfigFeatures, HCConfigRules } from './hc-config';

export const amapa: HCConfig = {
         appName: 'Saúde da Gente Telemedicina',
         hcId: '',
         isPublic: true,
         uf: 'AP',
         config: {
           trackingId: 'G-XDC94071PD',
           domain: 'app.saudedagentetelemedicina.ap.gov.br',
           domainKey: 'appAmapaDomainUrl',
           reactDomainKey: 'appAmapaDomainReactUrl',
           hcParam: 'amapa',
           clientDomainHeader: 'amapa',
           govBrClientId: 'cuidar-piaui-gov-pi',
           supportChatKey:
             'ODM3ZGQ5ZjMtMDM2OS00NGU2LTgxYjItMWVmMWZjODkwNWE1OmU4YmM0YjQwMjY4NTQ2ODFkZDM1ZDhmMDI3NWRjYTc4YTU2NTg3MjJjZXNwMDA3MG4yZ0FsQ0dzYzExS0lTOE9uejNtY3dvRmg1SzhvRDJqcWc=',
         },

         assets: {
           logo: './assets/hc/amapa/amapa-logo-04.png',
           uploadExternalFilesLogo: './assets/hc/amapa/amapa-logo-04.png',
           preloaderLogo: './assets/hc/amapa/amapa-logo.png',
           favicon: '/assets/hc/amapa/amapa-favicon.png',
         },

         links: {
           site: 'https://app.saudedagentetelemedicina.ap.gov.br',
           termsOfUse: 'https://saudedagentetelemedicina.ap.gov.br/termos-de-uso-amapa.html',
           policyPrivacy: 'https://saudedagentetelemedicina.ap.gov.br/politica-de-privacidade-amapa.html',
           playstore: 'https://play.google.com/store/apps/details?id=com.ptm.amapa',
           appstore: 'https://apps.apple.com/us/app/amapá-consulta/id6767002062',
         },

         dataDeletion: {
           name: 'Saúde da Gente Telemedicina',
           slug: 'amapa',
           agreementTermsUrl:
             'https://saudedagentetelemedicina.ap.gov.br/termo-de-consentimento-exclusao-conta-amapa.html',
           background: '#ffffff',
           logo: {
             src: HCConfigAssets.dataDeletionLogo('amapa'),
             width: 340,
             height: 154,
           },
         },

         firstAccess: {
           name: 'Saúde da Gente Telemedicina',
           city: 'Amapá',
           slug: 'amapa',
           emailDomain: '@saudeconsulta.ap.gov.br',
           abbreviation: 'ap',
           background: 'linear-gradient(45deg, #3300c7, #00c7ff 58%, #ffc300)',
           logo: {
             src: './assets/hc/amapa/amapa-logo-04.png',
             width: 300,
             height: 150,
           },
         },

         mealPlan: {
           enableDocumentCreation: false,
           enableSendFiles: true,
           documentTypes: {
             showMealPlan: true,
             showTherapeuticPlan: false,
             showNursingPlan: false,
           },
         },

         routes: {
           firstAccess: '/first-access/amapa',
         },

         features: [
           HCConfigFeatures.FIRST_ACCESS_SEE_MORE_CONTENT,
           HCConfigFeatures.FIRST_ACCESS_REGISTER,
           HCConfigFeatures.PROCEDURES_APAC_SADT,
           HCConfigFeatures.REFERRAL_GUIDE,
           HCConfigFeatures.REQUEST_ATTENDANCE,
           HCConfigFeatures.HC_ADM_CAN_CHANGE_PATIENT_PASSWORD,
           HCConfigFeatures.PATIENT_INVITE_AND_EDIT_FORM_INCLUDE_CNS,
           HCConfigFeatures.ENABLE_FIRST_ACCESS,
           HCConfigFeatures.MANCHESTER_QUESTIONNAIRE,
           HCConfigFeatures.VIOLENCE_VICTIM_IDENTIFICATION,
           HCConfigFeatures.PATIENT_COMPLEMENTARY_DATA_FORM_INCLUDE_ATYPICAL_CHILDREN_GUARDIAN,
           HCConfigFeatures.E_SUS_PROFESSIONAL_CLINICAL_HISTORY,
           HCConfigFeatures.CAMERA_MIC_PREVIEW_BEFORE_CALL_JOIN,
         ],

         rules: [
           HCConfigRules.PATIENT_INVITE_AND_EDIT_FORM_REQUIRE_CPF_OR_EMAIL_OR_CNS,
           HCConfigRules.APPOINTMENT_MANAGEMENT,
           HCConfigRules.HC_HAS_CNES,
           HCConfigRules.BLOCK_REGISTRATION_WITH_OUT_OF_STATE_ZIPCODE,
           HCConfigRules.PHYSICIAN_SIGNATURE_STATUS_WIDGET,
           HCConfigRules.DOCTORS_LIST_SHOW_DIGITAL_SIGNATURE_STATUS,
         ],
       };
